import styled from 'styled-components'

export const StyledExpandArrow = styled.span<{
  $expanded: boolean
  $rotation: string
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform: rotate(
    ${({ $expanded, $rotation }) => ($expanded ? $rotation : '0deg')}
  );
  transition: transform ${({ theme }) => theme.transitions.fast};
  color: ${({ theme }) => theme.colors.primary};
  flex-shrink: 0;
`
